import { post } from '..';

const createRole = (
  name: string,
  description: string,
  permissions: string[],
  roleColor: string,
) => post(
  'users/roles',
  {
    name,
    description,
    permissions,
    color: roleColor,
  },
);

export default createRole;
